export const ApartmentSingleTypes = {
  SHOW_APARTMENT_SINGLE_DEBT: 'SHOW_APARTMENT_SINGLE_DEBT',
  ADD_SINGLE_DEBT: 'ADD_SINGLE_DEBT',
}
